define(function (require) {
    "use strict";

    var LE = require("app");
    var DateUtility = require("utils/DateUtility");

    var ProfileListComparators = [];

    function moduleDefinition (LEUserManagement, LE, Backbone, Marionette, $, _) {
        //I wish these comparators where mre straight forward, alas AS user Model,AC user model may have different property names
        ProfileListComparators = [
            {
                name:"profileName",
                func:function(model){
                    return model.getName().toLowerCase();
                }
            },
            {
                name:"role",
                func:function(model){
                    return model.getRoleTypeId();
                }
            },
            {
                name: "description",
                func: function(model) {
                    return model.getDescription().toLowerCase();
                }
            },
            {
                name: "usersNum",
                func: function(model) {
                    return model.getNumOfAssingnedUsers();

                }
            }

        ];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfileListComparators;
});
